export default "__VITE_ASSET__CMektkKp__"